module.exports = __webpack_public_path__ + "static/img/menu4.09c080b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu4.png
// module id = LY/e
// module chunks = 0